import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Autocomplete, TextField, Chip } from '@mui/material';

export interface MultipleSelectOption {
  label: string;
  value: any;
  key?: number;
  group?: string;
}
export interface MultipleSelectDropdownProps {
  label: string;
  options: MultipleSelectOption[];
  selectedValues?: any[];
  placeholder?: string;
  noOptionsText?: string;
  handleChange: (valuesArray: any[]) => void;
}

const MultipleSelectDropdown: FC<MultipleSelectDropdownProps> = ({
  label,
  options,
  selectedValues,
  placeholder,
  handleChange,
  noOptionsText,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<MultipleSelectOption[]>(selectedValues || []);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedOptions(selectedValues || []);
  }, [selectedValues]);

  return (
    <Styled.TextInputContainer>
      <Autocomplete
        multiple
        id="multiple-autocomplete"
        options={options}
        groupBy={option => option.group}
        getOptionLabel={option => option.label}
        noOptionsText={noOptionsText || 'No Results found'}
        value={selectedValues || selectedOptions}
        onChange={(event, newValue) => {
          setSelectedOptions(newValue);
          handleChange(newValue);
        }}
        open={isOpen}
        onOpen={handleOpen}
        onBlur={handleClose}
        ListboxProps={{
          sx: {
            maxHeight: '400px',
          },
        }}
        renderTags={(selectedValues: readonly MultipleSelectOption[], getTagProps) =>
          selectedValues.map((option: MultipleSelectOption, index: number) => (
            <Chip label={option.label} {...getTagProps({ index })} key={option.key} />
          ))
        }
        renderInput={params => {
          return (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                notched: true,
              }}
              InputLabelProps={{
                ...params.InputLabelProps,
                shrink: true,
              }}
              label={label}
              sx={{ m: 1, width: '100%' }}
              placeholder={placeholder || undefined}
            />
          );
        }}
      />
    </Styled.TextInputContainer>
  );
};

export default MultipleSelectDropdown;

const Styled = {
  TextInputContainer: styled.div({
    marginBottom: '5px',
    width: '100%',
  }),
};
